import SplashScreen, { SplashScreenStatic } from "../../common/SplashScreen";

export function ClientSplashStatic() {
  return <SplashScreenStatic />;
}

export default function ClientSplash(props) {
  return <SplashScreen {...props} safetyTimeout defaultTagline="Ваш спортивный клуб" />;
}
